import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['summary', 'editor']

  edit (event) {
    event.preventDefault()
    this.show(true)
  }

  done () {
    this.show(false)
  }

  // Private

  show (editing) {
    this.summaryTarget.classList.toggle('hidden', editing)
    this.editorTarget.classList.toggle('hidden', !editing)
  }
}
